import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DragDropComponent } from './drag-drop.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { FlexLayoutModule } from '@angular/flex-layout';




@NgModule({
  declarations: [DragDropComponent],
  imports: [
    CommonModule,
    DragDropModule,
    FlexLayoutModule
  ],
  exports: [
    DragDropComponent
  ]
})
export class DragDropLModule { }
